/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_MoneyInputs */

const en_portal_nav_money = /** @type {(inputs: Portal_Nav_MoneyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Money`)
};

/** @type {(inputs: Portal_Nav_MoneyInputs) => LocalizedString} */
const ar_portal_nav_money = en_portal_nav_money;

/** @type {(inputs: Portal_Nav_MoneyInputs) => LocalizedString} */
const he_portal_nav_money = en_portal_nav_money;

/** @type {(inputs: Portal_Nav_MoneyInputs) => LocalizedString} */
const ur_portal_nav_money = en_portal_nav_money;

/** @type {(inputs: Portal_Nav_MoneyInputs) => LocalizedString} */
const es_portal_nav_money = en_portal_nav_money;

/** @type {(inputs: Portal_Nav_MoneyInputs) => LocalizedString} */
const fr_portal_nav_money = en_portal_nav_money;

/** @type {(inputs: Portal_Nav_MoneyInputs) => LocalizedString} */
const de_portal_nav_money = en_portal_nav_money;

/** @type {(inputs: Portal_Nav_MoneyInputs) => LocalizedString} */
const pt_portal_nav_money = en_portal_nav_money;

/** @type {(inputs: Portal_Nav_MoneyInputs) => LocalizedString} */
const hi_portal_nav_money = en_portal_nav_money;

/** @type {(inputs: Portal_Nav_MoneyInputs) => LocalizedString} */
const bn_portal_nav_money = en_portal_nav_money;

/**
* | output |
* | --- |
* | "Money" |
*
* @param {Portal_Nav_MoneyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_nav_money = /** @type {((inputs?: Portal_Nav_MoneyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_MoneyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_nav_money(inputs)
	if (locale === "he") return he_portal_nav_money(inputs)
	if (locale === "ur") return ur_portal_nav_money(inputs)
	if (locale === "es") return es_portal_nav_money(inputs)
	if (locale === "fr") return fr_portal_nav_money(inputs)
	if (locale === "de") return de_portal_nav_money(inputs)
	if (locale === "pt") return pt_portal_nav_money(inputs)
	if (locale === "hi") return hi_portal_nav_money(inputs)
	if (locale === "bn") return bn_portal_nav_money(inputs)
	return /** @type {LocalizedString} */ ("Money")
});